import React, { ReactNode } from 'react';
import { View, StyleSheet, Platform } from 'react-native';
import WebSidebar, { SIDEBAR_WIDTH } from './WebSidebar';
import { useTheme } from '../context/ThemeContext';

type Props = {
  children: ReactNode;
};

const WebDesktopLayout = ({ children }: Props) => {
  const { colors } = useTheme();

  if (Platform.OS !== 'web') {
    return <>{children}</>;
  }

  return (
    <View style={[styles.shell, { backgroundColor: colors.background.paper }]}>
      <WebSidebar />
      <View style={[styles.main, { backgroundColor: colors.background.paper }]}>{children}</View>
    </View>
  );
};

const styles = StyleSheet.create({
  shell: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'stretch',
    minHeight: '100vh' as unknown as number,
    width: '100%',
  },
  main: {
    flex: 1,
    minWidth: 0,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
  },
});

export default WebDesktopLayout;
